module.exports = __webpack_public_path__ + "img/渔场预报.965758f5.png";